module.exports = __webpack_public_path__ + "static/two-tier-22f8bb450f8250f50655022b098a6c13.jpg";